
export default {
  home: {
    Home: '直播',
    Hot: '热门',
    Match: '赛程',
    Message: '消息',
    Friend: '好友',
    Me: '我的',
    Tab_0: '推荐',
    Tab_1: '足球',
    Tab_2: '篮球',
    Tab_3: '电竞',
    Tab_4: '新闻',
    Tab_5: '午夜场',
    Tab_6: '回放',
    index_title_zb: '正在热播',
    index_title_jc: '精彩集锦',
    index_title_mx: '明星主播',
    index_title_qq: '电子竞技',
    index_title_kx: '今日快讯',
    more: '更多',
    jrrm: '今日热门',
    jumpTop: '回到顶部',
    onFocus: '关注',
    reply: '条回复',
    allComment: '全部评论',
    remen: '热门',
    saiguo: '赛果',
    bsjj: '比赛集锦',
    qwzk: '全网赛事最全·播放最快',
    lggg: '免费下载享蓝光、投屏',
    downapp: '下载APP',
    anchortalk: '主播解说',
    currentsound: '现场原声',
    movieplayback: '录像回放',
    hightqulity: '高清',
    pushlish: '发布',
    abautanchor: '相关主播',
    areadyfocus: '已关注',
    focus: '关注',
    abautlive: '相关直播',
    abautmatch: '相关赛程',
    yi: '亿',
    wan: '万',
    unkowntype: '未知类型',
    ballcircle: '球圈',
    staranchor: '明星主播',
    renhot: '人气: ',
    veryonesearch: '大家都在搜索',
    searchplace: '搜索感兴趣的内容',
    zhongyao: '主播',
    worldCupSchedule: '赛程',
    worldCupScore: '比分',
    worldCupNews: '资讯',
    tabIdx: '1',
  },
  play: {
    chat: "聊天",
    userzb: "主播",
    saik: "赛况",
    zr: "阵容",
    zs: "指数",
    zb: "直播",
    fx: "分析",
    zbNoLine: '主播暂时没在直播',
    zbNoLine2: '关注主播可清楚开播提醒哦～',
    joinInRoom: '加入了聊天室',
    textLive: '文字直播',
    tongji: '技术统计',
    team: '球队',
    teamTj: '球队统计',
    teamUserTj: '球员统计',
    yz: "亚指",
    rq: "让球",
    jqs: "进球数",
    zf: "总分",
    zlly: "赔率来源",
    fhv: "返还率",
    win: "胜",
    draw: "平",
    owe: "负",
    number: '号码',
    teamUser: '球员',
    starter: '首发',
    time: '时间',
    score: '得分',
    lb: '篮板',
    zg: '助攻',
    tl: '投篮',
    sanfen: '三分',
    fq: '罚球',
    qd: '抢断',
    qb: '前板',
    hb: '后板',
    gm: '盖帽',
    sw: '失误',
    fg: '犯规',
    chatText: '球要一起聊才high~',
    gxzg: '各项最高',
    lsjz: '历史交战',
    sv: '胜率',
    ypl: '赢盘率',
    dql: '大球率',
    ying: '赢',
    shu: '输',
    zou: '走',
    xiao: '小',
    da: '大',
    jqzt: '近期状态',
    tss: '同赛事',
    rqss: '日期/赛事',
    dz: '对阵',
    dx: '大小',
    copyline: '复制链接',
    sixin: '私信',
    fensi: '粉丝',
    fds: '防丢失请记住备用域名',
    ordownapp: '或者下载app',
    lodingtext: '聊天正在加载中',
    disstartmatch: '距离比赛开始',
    zhu: '主',
    ke: '客',
    chatHost: '联系客服'
  },
  match: {
    jumpNowDay: '回到今天',
    refresh: '刷新',
    mathDay: '赛事日期',
    ban: '半',
    jiao: '角',
    huangguan: '皇冠',
    libo: '立博',
    mingh: '明陞',
    bocai: '澳彩',
    wlxe: '威廉希尔',
    ysb: '易胜博',
    wd: '韦德',
    lij: '利记',
    yih: '盈禾',
    pb: '平博',
    year: '年',
    moon: '月',
    nowDay: '今天',
    onlive: '直播中',
    dej: '第二节',
    matcherr: '比赛异常',
    nomatch: '未开赛',
    dyj: '第一节',
    dyjo: '第一节完',
    dejo: '第二节完',
    dsj: '第三节',
    dsjo: '第三节完',
    dsjj: '第四节',
    matchjs: '加时',
    matchwc: '完场',
    matchtc: '推迟',
    matchzd: '中断',
    matchyz: '腰斩',
    matchdd: '待定',
    matchsfqrqs: '3分球进球数',
    matchefqrqs: '2分球进球数',
    matchfqjqs: '罚球进球数',
    matchsyzts: '剩余暂停数',
    matchfgs: '犯规数',
    matchfqmzl: '罚球命中率',
    matchzzts: '总暂停数',
    matchzg: '进攻',
    matchwxjg: '危险进攻',
    matchkql: '控球率',
    matchszqm: '射正球门',
    matchjq: '进球',
    matchdq: '点球',
    matchzg1: '助攻',
    matchtime: '时间',
    matchhp: '红牌',
    matchhp2: '黄牌',
    matchsm: '射门',
    matchsz: '射正',
    matchgr: '过人',
    matchgrcg: '过人成功',
    matchjw: '解围',
    matcyxzd: '有效阻挡',
    matclj: '拦截',
    matcqd: '抢断',
    matccq: '传球',
    matccqcg: '传球成功',
    matchczq: '传中球',
    matchczqcg: '传中球成功',
    matchcco: '长传',
    matchccok: '长传成功',
    matchpq: '拼抢',
    matchpqcg: '拼抢成功',
    matchdqe: '丢球',
    matchfg: '犯规',
    matchbqf: '被侵犯',
    matchpj: '扑救',
    matchqjq: '拳击球',
    matchsmycj: '守门员出击',
    matchcjcg: '出击成功',
    matchgkcj: '高空出击',
    matchpf: '评分',
    matchjqs: '角球',
    matchjwq: '界外球',
    matchryq: '任意球',
    matchqmq: '球门球',
    matchhr: '换人',
    matchbsks: '比赛开始',
    matchzc: '中场',
    matchjsg: '结束',
    matchbcbf: '半场比分',
    matchlhbh: '两黄变红',
    matchdqwj: '点球未进',
    matchwlq: '乌龙球',
    matchstbs: '伤停补时',
    matchsp: '射偏',
    matchjssjs: '加时赛结束',
    matchjdqdz: '点球大战结束',
    matchvar: 'VAR',
    matchspqm: '射偏球门',
    matchzysj: '重要事件',
    matchjss: '加时赛',
    matchdqjs: '点球决战',
    no: '无',
    chang: '场',
    tzk: '同主客',
    yes: '是',
    nos: '否',
    xiaojie: '小节',
    noLiveMatch: '暂未开播',
  },
  noData: {
    noComment: '暂无评论，说说你的看法',
    noSearch: '暂无搜索结果',
    noMatch: '目前暂无比赛',
    nobifen: '暂无比分数据',
    noLive: '去看看别的吧，精彩正在直播中',
    nogroup: '暂无添加群组',
    noNewfriend: '暂无好友添加',
    noqgg: '去逛逛吧，发现喜欢的主播别忘了点关注哦',
    nozb: '暂无关注主播',
    noMsg: '暂无消息',

  },
  tips: {
    shareMatch: '分享比赛成功',
    copySuccess: '复制成功',
    changeLine: '切换视频线路',
    line: '线路',
    cancel: '取消',
    tosendZb: '快去和主播说要进群哦',
    tosendhd: '快去和主播互动哦',
    addzb: '添加主播为好友，预测推荐少不了',
    gd: '更多主播等你添加咨询～',
    tickoutgroup: '您已被踢出群聊',
    youforbid: '您已被禁言',
    younotin: '聊天室不存在',
    nomoredata: '没有更多了',
    month: '月',
    day: '日',
    today: '今天',
    kkry: '空空如也~',
    ptaddress: '平台备用网址',
    downloadApp: '下载APP',
    qwzk: '全网赛事最全·播放最快',
    lgtp: "免费下载享蓝光、投屏",
    myInvite: '我的邀请',
    gjyaoqing: '共计邀请：',
    copyInviteLink: '复制分享链接',
    person: '人',
    chatcontent: '聊天内容',
    addHomeScreen: '添加到主屏幕',
    beat40: "您已经打败全国40%的用户",
    beat60: "您已经打败全国60%的用户",
    beat78: "您已经打败全国78%的用户",
    beat88: "您已经打败全国88%的用户",
    beat98: "您已打败了全国98%的用户",
    haicha: '还差',
    czzksj: '成长值可升级',
    forbid: '禁言中',
    loadFail: '加载失败',
    notSuport: '您的浏览器不支持video',
    forwardApp: '消息类型暂不支持,请前往app查看',
    photo: '照片',
    video: '视频',
    file: '文件',
    redpot: '红包',
    upload: '上传中',
    uploadFail: '上传失败！',
    yybtcql: '您已被踢出群聊',
    yybjy: '您已被禁言',
    ltsbcz: '聊天室不存在',
    sunday: '星期日',
    monday: '星期一',
    tuesday: '星期二',
    wednesday: '星期三',
    thursday: '星期四',
    friday: '星期五',
    saturday: '星期六',
    search: '取消',
  },
  im: {
    edit: '编辑',
    search: '搜索',
    inputPlaceholder: '请输入搜索关键词',
    allin: '全部',
    add: '添加',
    group: '群聊',
    agree: '已同意',
    reject: '已拒绝',
    pass: '通过',
    subitFriend: '申请加为好友',
    activity: '活动中心',
    sedkf: '说说你的看法',
    allSel: '全选',
    yidu: '标记已读',
    wanc: '完成',
    online: '在线',
    nowonline: '当前在线',
    latestonline: '最近上线',
    contact: '联系人',
    newFriend: '新的好友',
    mygfoup: '我的群组',
    mygscj: '我是你最好的快乐收藏夹',
    wntuij: '为你推荐',
    sound: '[语音]',
    video: '[视频]',
    image: '[图片]',
    redpot: '[红包]',
    link: '[链接]',
    card: '[名片]',
    getredpot: '[获取红包]',
    getreadysound: '[准备开始实时语音]',
    transfer: '[转账]',
    groupcard: '[群名片]',
    recall: '撤回消息',
    checkorder: '[确认订单]',
    file: '[文件]',
    zfhxx: '[支付号消息]',
    pay: '[小程序]',
    ad: '[广告]',
    talkover: '[通话结束]',
    tips: '[提示]',
    grouptips: '[群申请提示]',
    groupconfirm: '[群申请确认]',
    notyoufriend: '[对方不是好友]',
    linknotyoufriend: '[邀请链接加群]',
    groupsend: '[群发]',
    groupNotice: '群公告',
    shouqi: '收起',
    zhangkai: '展开',
    groups: '群'
  },
  me: {
    onLogin: '点击登录',
    tipsregst: '注册参与更多活动福利',
    sign: '签到',
    onsign: '已签到',
    jfsc: '积分商城',
    zbxg: '主播相关',
    gkls: '观看历史',
    wddj: '我的等级',
    yqhy: '邀请好友',
    zxkf: '在线客服',
    zxzh: '注销账号',
    yqhydjf: '邀请好友得积分',
    yjfk: '意见反馈',
    gywm: '关于我们',
    setting: '设置',
    lvxl: '新秀',
    lvht: '黄铜',
    lvby: '白银',
    lvhj: '黄金',
    lvbj: '铂金',
    lvzs: '钻石',
    lvbyqt: '白银球童',
    lvhtqm: '黄铜球迷',
    lvhjqy: '黄金球员',
    lvbjqx: '铂金球星',
    lvzsqw: '钻石球王',
    srmi: '输入密码',
    qdcg: '签到成功',
    jfgz: '积分规则',
    text3: '3：每日观看比赛时长10分钟',
    text1: '1：积分商城是本平台为广大用户提供的免费福利，只要您 能成为我们的用户即可获取积分。积分可以用来兑换超值礼品， 也可以兑换平台福利。',
    text1_2: '1：积分商城是本平台为广大用户提供的免费福利，只要您 能成为我们的用户即可获取积分。积分可以用来兑换超值礼品。',
    sigin1: '这个用户很懒，还没有填写个人简介',
    quxiaocg: '取消成功',
    fzfxlj: '复制分享链接',
    addimg: '添加图片',
    zonecode: '区号',
    zonecodedef: '86',
    inputphone: '请输入您的手机号码',
    videohp: '视频画面黑屏',
    mbf: '没有比分',
    sxcg: '刷新成功',
    qsrplnr: '请输入评论内容',
    srname: '输入你的名字',
    tgcggg: '提交成功，稍后工作人员会联系你',
    zbxxsc: '主播信息上传',
    qsrsfz: '请输入身份证号码',
    zbnoid: '主播没有设置id',
    gzzb: '关注主播',
    lxkf: '联系客服',
    phone: '手机号',
    code: '验证码',
    dxyzm: '短信验证码',
    hqyzm: '获取验证码',
    symmdl: '使用密码登录',
    dl: '登录',
    wyydbty: '我已阅读并同意',
    rjfwyx: '《软件许可及服务协议》',
    zhen: '账号',
    inputname: '输入账号',
    jxgg: '继续逛逛',
    yzmdl: '验证码登录',
    mm: '密码',
    qsrnc: '请输入昵称',
    jrqdhd: '今日签到获得',
    textnone: '一.如何获得积分',
    text4: '4：邀请新用户分享app',
    text2: '2：商城的商品只能用积分兑换,不可以用现金等其他方式获取。',
    signname: '签名',
    gzcg: '关注成功',
    fzljcg: '复制成功',
    zdyz: '(最多一张)',
    submit: '提交',
    mflt: '没法聊天',
    bsts: '比赛太少',
    abouttext1: '作为新一代互联网综合体育媒体平台，拥有中超、亚冠、英超、意甲、法甲、西甲、欧冠、欧洲杯、世界杯等超50项重量级别国内国际体育赛事版权，成为大量垂直体育用户观看，聊赛事互动体育平台。',
    tpisnodata: '您还没输入内容',
    plcg: '评论成功',
    srndsjh: '输入你的手机号码',
    oninutphone: '请正确填写手机号码',
    zjhm: '证件号码',
    tccg: '退出成功',
    mhtcsy: '秒后返回首页',
    nrwk: '内容为空',
    tyfwxy: '请同意服务协议',
    qsrmm: '请输入密码',
    newpass: '新密码',
    inputnewpass: '输入新密码',
    grzl: '个人资料',
    avatar: '头像',
    username: '昵称',
    gxqm: '个性签名',
    nosetting: '未设置',
    xtavatar: '系统头像',
    xc: '相册',
    qxztx: '请选择头像',
    wjbncg: '文件大小不能超过1m',
    imgsubimterr: '图片上传失败,请稍后重试',
    tpscz: '图片上传中',
    qscjpg: '请上传 jpg/png 格式图片',
    scz: '上传中...',
    hqsb: '获取系统头像失败',
    szcg: '设置成功',
    sznc: '设置昵称',
    xlqd: '你已连续签到',
    tian: '天',
    mrqd1: ' 1：每日签到',
    mrqd2: ' （连续签到7天额外获得积分礼包）',
    aboutjfsc: '二.关于积分商城',
    jfdhjp: '3：积分兑换奖品需提供正确的地址、电话及收件人，本平台将负责全国包邮。',
    mygdl: '没有更多了',
    zzzb: '直播中',
    fklex: '反馈类型',
    fkcgprd: '(反馈成功有机会可获得福利)',
    tgcg: '提交成功',
    syhm: '声音画面不同步',
    cpty: '产品体验',
    testx1: '致力于打造服务全球球迷的互联网体育平台，在业务创新式推出垂直独立体育app，通过强化交互、创造更丰富、更全面的体育内容实现了7x24小时全时段咨询服务。',
    ltpf: '聊天太过频繁，请稍后尝试~',
    mmbns6: '密码不能少于6位',
    srxxdz: '输入你的详细地址',
    qzqtx: '请正确填写资料',
    qsrzsmz: '请输入真实名字',
    nylqgl: '您已领取过了',
    nccccc: '1.昵称1天内只可修改一次,不得超过6个字符。',
    textnc: '2.昵称只允许输入中文',
    textnc3: '3.昵称修改成功后,若经人工审核违规将被重置。',
    ncxt: '昵称相同，请修改后再提交',
    ncbnwk: '昵称不能为空',
    idszh: 'ID是账号的唯一凭证，不可修改',
    szgxqm: '设置个性签名',
    qsrgxqm: '请输入您的个性签名',
    qsxt: '签名相同，请修改后再提交',
    qsbnwk: '签名不能为空',
    jfgza: '规则',
    lxqdyjx: '连续签到 赢惊喜礼包',
    jfmx: '积分明细',
    jfdhzq: '积分兑换专区',
    ckwdhd: '查看我兑换的商品',
    jfci: '积分/次',
    jf: '积分',
    dh: '兑换',
    dhsy: '使用积分兑换后，不可撤销',
    ckkdh: '查看可兑换商品',
    zbgphd: '2：直播公屏互动）',
    zbgphd2: '(每日一次）',
    smjfsc: '什么是积分商城？',
    textp4: '4：平台有权随时调整积分商城规则并进行公告，如遇活动漏洞 或者大规模作弊行为，包括不限于按照非正常流程获取权益， 本平台有权在相关规定允许范围内直接下线活动并保留回收 权益，保留变更本规则与条款的权力。',
    qxgz: '取消关注',
    lsjl: '历史纪录',
    fknr: '反馈内容',
    gxydkn: '更新遇到困难',
    bstk: '比赛看起来太卡',
    qsrnyfk: '请输入你要反馈的信息',
    wl1: '未来',
    wlyt: '将依托赛事运营专业性，探索多产业跨界互联，构建全场景用户服务生态。聚焦体育内容兴趣球圈，持续以领先行业IP运营能力服务体育用户，带来领先行业的体育赛事，打造体育内容咨询，打造有态度的体育健康平台，让热爱更加热爱',
    xtts: '系统提示：本直播努力营造积极健康的直播环境，对直播内容进行24小时巡查， 任何传播违法、违规、诈骗、低俗不良、血腥暴力封建迷信等信息的行为一经发 现，将对违规者账号予以封号处理。',
    chgangsu: '修改成功',
    inputcode: '输入你的邮政编码',
    yazfa: '验证码已发送',
    xingming: '姓名',
    lingquceng: '领取成功',
    loginSucces: '登录成功',
    backhome: '返回首页',
    inputphonecode: '输入验证码',
    setPass: '设置密码',
    yset: '已设置',
    out: '退出',
    setpasstips: '设置密码后可以通过账号+密码直接登录',
    ok: '确定',
    pssmy: '密码验证',
    zxhb: '专项红包',
    zxhbjf: '专享的积分红包',
    lq: '领取',
    ylq: '领取',
    mystatk: '我的任务',
    mystat2k: '成长值',
    qbtj: '全部统计',
    zbgg: '主播公告',
    nozbgg: '该主播还未填写公告',
    xianlu: '线路',
    gxni: '恭喜你获得现金红包',
    gxsssni: '前往私信主播领取哦～',
    loding: '数据正在加载中，耐心等候一下哦～',
    yuan: '元',
    sedmsg: '给你发送了一条信息',
    chakan: '查看',
    del: '删除',
    sp: '升盘',
    jp: '降盘',
    gs: '高水',
    ds: '低水',
    pkly: '盘口来源',
    cspk: '初始盘口',
    jspk: '即时盘口',
    qy: '球员',
    sf: '首发',
    mtsc: '(每天3次)',
    sq: '收起',
    sfzr: '首发阵容',
    tbzr: '替补阵容',
    zx: '阵型',
    chu: '初',
    ji: '即',
    lhyh: '两黄一红',
    wl: '乌龙',
    sjhgscw: '手机号格式错误',
    inputsjyzm: '请输入手机验证码',
    inputzonecode: '请输入区号',
    loginsuccback: '登录成功，3秒后返回首页',
    loginsucc: '登录成功，',
    threeback: '秒后返回首页',
    loginfail: '登录失败。',
    welcome: '欢迎来到',
    logintips: '手机号码直接登录，无需注册',
    integralExchange: "兑换成功",
    integralSuccess: "恭喜你兑换成功",
    integralExchanged: "已兑换积分",
    integralNumber: '剩余积分',
    integralContinue: '继续兑换',
    integralTips: '*请在兑换的商品里完善好自己的收货地址，工作人员确认过后会自动发货，因系统原因，无法提供物流信息；',
    texttoolong: '字符不能大于6个',
    nickMdySucc: '修改昵称成功',
    onlyUseChina: '昵称只能使用汉字，请重新输入',
    addaddress: '添加地址',
    addressdetail: '输入你的详细地址、地区以及街道门牌信息',
    inputdetail: '*注意：确保商品可正确寄送到您的地址上，地址应当详细填写，只有一次填写机会，完成后会在1～3个工作日发出。',
    integralex: '由积分兑换获得',
    delaccount: "注销账号请认真阅读一下,提醒:",
    delaccontent1: "为防止误操作，请再次确认是否注销账号并确认注销后的影响。在此善意提醒，注销账号为不可恢复的操作，建议在最终确定注销前自行备份账号相关的所有信息并再次确认与账号相关的服务均已进行妥善的处理。包括但不限于：",
    delaccontent2: "1. 本账号的个人资料和历史信息(包括头像，用户，发布内容，浏览记录等)都将无法找回",
    delaccontent3: "2. 你将无法登录，使用本账号。",
    delaccontent4: "3. 通过本账号使用，授权登录或绑定本账号后使用的第三方账号的相关账号将无法找回。你将无法再登录使用上述服务，你增获得的虚拟权益等财产利益视为你自动放弃，将无法继续使用。你理解并同意，本App无法协助你重新恢复上述服务,注销账号后，绑定的手机会被解绑，解绑后可再次注册，请谨慎操作",
    delaccontent5: "输入当前完整的UID并点击确认后, 你的账号将被不可逆的注销，请慎重考虑！！！",
    delaccontent6: "请输入完整的UID",
    delaccontent7: "请输入UID",
    delaccontent8: "您输入的ID不正确",
    submitted: '已提交',
    success: '成功',
    failed: '失败',
    invitecode: '邀请码',
    inputInviteCode:'选填',
    withdrawFailed: '兑换失败',
    inputaccount: '请输入账号(6-20字母+数字)',
    inputpassword: '请输入密码(6-20位数字或字母)',
    inputpasswordagain: '请再次输入密码',
    accountInvalid: '账号不符合规范',
    gotoLogin: '去登录',
    gotoRegister: '去注册',
    querenpwd: '确认密码',
    inputnickname: '输入昵称',
    register: '立即注册',
    pwsswordInvalid: '请正确输入密码',
    pwsswordNotSame: '两次输入的密码不一致',
    setAccPwd: '设置账号密码',
    setAccPwdSubTitle: '设置成功后，可使用账号密码进行登录',
    inputOldPassword: '请输入原来的密码',
    newPassword: '新密码',
    oldPassword: '旧密码',
    passwordIsSame: '新密码与旧密码不能一致',
    accPwdError: '账号或密码不正确',
    nickNameErr: '昵称必须是6-20位字母、数字或常见字符组成',
    accountRepeated: '该账号已存在',
    nicknameRepeated: '该昵称已存在',
    setSucc: '设置信息成功', 
    regSucc: '注册成功，正在自动登录',
    switchAccount: '切换账号',
  },
  'jinqiu': '进球',
  'focuSucc': '关注成功',
  'cancelFocus': '取消关注成功',
  'clearCache': '清理缓存',
  "复制": "复制",
  "邀请的人数": "邀请的人数",
  "查看记录": "查看记录",
  "可兑换积分": "可兑换积分",
  "兑换话费": "兑换话费",
  "兑换彩金": "兑换彩金",
  "立即邀请": "立即邀请",
  "记录": "记录",
  "好友记录": "好友记录",
  "兑换记录": "兑换记录",
  "兑换": "兑换",
  "确认兑换奖金吗？": "确认兑换奖金吗？",

  "规则":"规则",
  "碎片":"碎片",
  "转盘次数":"转盘次数",
  "奖品兑换":"奖品兑换",
  "每日奖励":"每日奖励",
  "每日登录JALALIVE并观看比赛":"每日登录JALALIVE并观看比赛",
  "转盘机会 +1":"转盘机会 +1",
  "活动规则":"活动规则",
  "确认兑换吗？":"确认兑换吗？",
  "谢谢惠顾":"谢谢惠顾",
  "恭喜您获得":"恭喜您获得",
  "未达成":"未达成",
  "领取":"领取",
  "已领取":"已领取",
  "数据异常或网络异常":"数据异常或网络异常",
  "兑换成功":"兑换成功",
  "兑换失败":"兑换失败",
  "收下":"收下",
  "立即参与":"立即参与",

  "兑换奖品":"兑换奖品",
  "兑换积分":"兑换积分",
  "兑换奖励":"兑换奖励",
  "前往JalaLive积分商城":"前往JalaLive积分商城",
  "积分可以去兑换商品":"积分可以去兑换商品",
  "前往":"前往",

  "非法手机号":"非法手机号",
  "发送短信失败":"发送短信失败",
  "温馨提示":"温馨提示",
  "您尝试登录的手机号已存在绑定的账号，请使用账号密码登录。平台即将移除手机号验证码登录方式":"您尝试登录的手机号已存在绑定的账号，请使用账号密码登录。平台即将移除手机号验证码登录方式",
  "我知道啦":"我知道啦",
  "通知":"通知",
  "平台即将移除手机号验证码登录方式，系统已自动为您生成账号，请补全其他信息，后续请使用账号密码登录！":"平台即将移除手机号验证码登录方式，系统已自动为您生成账号，请补全其他信息，后续请使用账号密码登录！",
  "账号（不可更改）":"账号（不可更改）",
  "设置密码":"设置密码",
  "请输入密码":"请输入密码",
  "设置邮箱（用于找回密码，可选）":"设置邮箱（用于找回密码，可选）",
  "请输入邮箱":"请输入邮箱",
  "忘记密码？":"忘记密码？",
  "邮箱验证":"邮箱验证",
  "请输入验证码":"请输入验证码",
  "获取验证码":"获取验证码",
  "邮箱格式不正确":"邮箱格式不正确",
  "温馨提示：如果您没有绑定过邮箱，请联系客服找回密码":"温馨提示：如果您没有绑定过邮箱，请联系客服找回密码",
  "设置邮箱":"设置邮箱",
  
  "温馨提示：绑定邮箱可用于找回密码":"温馨提示：绑定邮箱可用于找回密码",
  "奖品剩余：":"奖品剩余：",
  "VIP折扣说明":"VIP折扣说明",
  "VIP折扣":"VIP折扣",
  "无折扣":"无折扣",
  "折":"折",
  "查看VIP详情":"查看VIP详情",
  "礼物折扣":"礼物折扣",
  "支付":"支付",

  "竞猜":"竞猜",
  "我的积分":"我的积分",
  "竞猜记录":"竞猜记录",
  "截止时间":"截止时间",
  "选择下注积分":"选择下注积分",
  "下注":"下注",
  "下注成功":"下注成功",
  "比赛":"比赛",
  "竞猜结果":"竞猜结果",
  "竞猜成功":"竞猜成功",
  "竞猜失败":"竞猜失败",
  "未开奖":"未开奖",
  "投注失败，积分不足":"投注失败，积分不足",

  "（主）":"（主）",
  "（客）":"（客）",
  "主队赢":"主队赢",
  "平":"平",
  "客队赢":"客队赢",
  "版本":"版本",

  "查看详情":"查看详情",
  "斗鸡":"斗鸡",
  "体育":"体育",
  "分钟前":"分钟前",
  "小时前":"小时前",

  "(在线中…)":"(在线中…)",
  "暂无群组":"暂无群组",
  "暂无与主播私聊信息":"暂无与主播私聊信息",
  "请找主播添加您进群获得福利":"请找主播添加您进群获得福利",
  "请私信主播吧~":"请私信主播吧~",
  "主播私聊":"主播私聊",
  "群组":"群组",
  "发送":"发送",

  "您的聊天已受限，请联系主播或客服":"您的聊天已受限，请联系主播或客服",
  "发送失败，未知错误":"发送失败，未知错误",
};
